export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const CLEAR_CURRENT_USER = "CLEAR_CURRENT_USER";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_TREKS = "SET_TREKS";
export const UPDATE_USER = "UPDATE_USER";

export const setCurrentUser = (token, user, treks) => ({
   type: SET_CURRENT_USER,
   payload: { token, user, treks },
});
export const setUserData = (obj) => ({
   type: SET_USER_DATA,
   payload: obj,
});

export const clearCurrentUser = () => ({
   type: CLEAR_CURRENT_USER,
});

export const setTreks = (obj) => ({
   type: SET_TREKS,
   payload: obj,
});
export const updateUser = (obj) => ({
   type: UPDATE_USER,
   payload: obj,
});
